// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"406":"37130c83","681":"74b8ecb5","1581":"c6eb344c","2040":"01e87510","2439":"5cb2b6e8","3859":"5cb2b6e8","5360":"1ae7d256","5472":"37130c83","5847":"37130c83","5930":"37130c83","6181":"fef1dec8","8609":"7550b5e9","8853":"d6b9f392"}[chunkId] + ".chunk.css";
};